import { render } from "./vactivityList.vue?vue&type=template&id=610d61e1&scoped=true"
import script from "./vactivityList.vue?vue&type=script&lang=js"
export * from "./vactivityList.vue?vue&type=script&lang=js"

import "./vactivityList.vue?vue&type=style&index=0&id=610d61e1&scoped=true&lang=scss"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610d61e1"]])

export default __exports__